import { frontendRelease } from "utilities/release";
import { getBackendRelease } from "utilities/backendRelease";
import { displayedRelease, versionLabel } from "utilities/supportDetails";

/**
 * The Hub's version label as copied into support details (SCHED-658/716):
 * "OMCi v1.0.1 · Production · 30 Sep 2026" — the same rule as the label in
 * components/Standalone/AppVersion.jsx (the backend's version and date when it is
 * higher), in English like the rest of the copied text. Shared by the Hub's own copy
 * and the launcher's (handed over via OMCHub.setDisplayedVersion in HubWidget).
 *
 * `envName` is the runtime OMC_ENV_TAG name, the fallback when NEXT_PUBLIC_ENVIRONMENT is unset.
 */
export function hubVersionLabel(envName, backend = getBackendRelease()) {
    const frontend = frontendRelease();
    const shown = displayedRelease(frontend, backend);
    return versionLabel({ version: shown.version, environment: frontend.environment || envName, releaseDate: shown.releaseDate });
}
